/** 24-char hex MongoDB ObjectId string */
export const OBJECT_ID_RE = /^[a-f0-9]{24}$/i;

export function isMongoObjectId(value) {
  return typeof value === 'string' && OBJECT_ID_RE.test(value);
}

/** Never show a raw ObjectId as a display name */
export function safeDisplayName(value, fallback = '') {
  if (!value) return fallback;
  if (typeof value === 'string' && isMongoObjectId(value)) return fallback;
  return value;
}
